<template>
  <ion-modal :is-open="show" :backdrop-dismiss="backdropDismiss" :keyboard-close="false">
    <slot></slot>
  </ion-modal>
</template>

<script>
import { IonModal } from '@ionic/vue';

export default {
  name: 'BaseModal',
  components: { IonModal },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    backdropDismiss: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
